export default "__VITE_ASSET__BzqHuk12__"